<template>
  <div class="article-list">
    <div class="container">
      <RouterLink v-for="item in articleList" :key="item.id"
                  :to="{ name: 'articleById', params: { locale: $i18n.localePath(), id: item.id }}"
                  :title="item.subject" class="article"
      >
        <div v-cover-lazy-loader :data-src="item.cover" :data-default-src="'/img/cover-social/read.png'" class="cover">
          <!--  -->
        </div>
        <div class="info">
          <span class="subject">
            {{ item.subject }}
          </span>
          <span class="content" v-html="item.authors.map(author => author.name).join('、') + ' / ' + (item.short_content || item.content)" />
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'
export default {
  name: 'ReadArticleList',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {
    articleList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    coverBackgroundImage(article) {
      return article && article.cover
        ? { backgroundImage: `url(${article.cover}` }
        : {} // default img in scss
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-list {
  .article {
    display: block;
    min-height: 147px;
    outline: none;
    // border: solid 1px salmon;
    overflow: hidden;
    .cover,
    .info {
      display: inline-block;
      vertical-align: top;
      text-decoration: none;
      outline: none;
    }
    .cover {
      float: left;
      width: 205px;
      height: 108px;
      margin-right: 28px;
      border-radius: 4px;
      border: solid 1px $grey-ec;
      background-color: $grey-ec;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      cursor: pointer;

    }
    .info {
      float: left;
      width: calc((100% - 205px) - 28px);
      overflow: hidden;
      .subject {
        display: block;
        width: 100%;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.6;
        text-decoration: none;
        color: $grey-50;
        cursor: pointer;

        white-space: nowrap; // Don't use with display: -webkit-box;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .content {
        display: block;
        height: 78px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.63;
        color: $grey-9b;

        @include ellipsis-with-lines(3);
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  .article-list {
    .article {
      .cover {
        width: 110px;
        height: 110px;
        margin-right: 16px;
      }
      .info {
        width: calc((100% - 110px) - 16px);
        .subject {
          max-height: 64px;
          font-size: 20px;
          white-space: unset;
          @include ellipsis-with-lines(2);
        }
        .content {
          height: 36px;
          font-size: 12px;
          @include ellipsis-with-lines(2);
        }
      }
    }
  }
}
</style>
